import type { ReactNode } from 'react'

import styles from './StatusBadge.module.css'

export type StatusTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger'

export function StatusBadge({
  children,
  icon,
  pulse = false,
  tone = 'neutral',
}: {
  children: ReactNode
  icon?: ReactNode
  pulse?: boolean
  tone?: StatusTone
}) {
  return (
    <span className={`${styles.badge} ${styles[tone]}`}>
      {pulse ? <i className={styles.pulse} aria-hidden="true" /> : icon}
      {children}
    </span>
  )
}
